import { projectLabel } from '@/utils/projectLabel.mjs'

export default {
  data () {
    return {
      projectObj: null
    }
  },
  computed: {
    printProjectName () {
      if (this.projectObj) return this.setProjectname(this.projectObj)
      else return ''
    }
  },
  methods: {
    getProject (id) { // project id
      this.$api.execute('get', `projects/${id}`).then(response => {
        if (response && response.data) this.projectObj = this.$formatter.cloneVariable(response.data)
      })
    },
    setProjectname (project) {
      // 4993 A6: "number - po_name - customer" once the API sends customer_name;
      // today's label otherwise (utils/projectLabel.mjs, node-tested).
      return projectLabel(project)
    },
    setEquimentName (equipment) {
      let equipmentName = ''
      equipmentName += equipment.equipment_number ? `${equipment.equipment_number} - ` : ''
      equipmentName += equipment.name ? equipment.name : ''
      return equipmentName
    },
    setChemicallistName (chemicallist) {
      const chemicallistName = chemicallist.name ? chemicallist.name : ''
      return chemicallistName
    }
  }
}
